import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarTiposRequest } from './types';

// ACTIONS
import { atualizarTiposSuccess, atualizarTiposFailure } from './actions';

function* atualizarTipos(request: ReducerActionRotaSP) {
	const { token, payload }: { token?: string; payload: AtualizarTiposRequest } =
		request;

	const body = { ...payload };

	delete body.codigo;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`tipos-localidade/${payload.codigo}`,
		body,
	);

	if (response.status === 200) {
		yield put(atualizarTiposSuccess(response));
	} else {
		yield put(atualizarTiposFailure());
	}
}

export default all([takeLatest(Types.ATUALIZAR_TIPOS, atualizarTipos)]);
